export default __webpack_public_path__ + "static/eneAcademyBackgroundForm-dc9c580c37fa5e2a5343f281544f0d27.png";